<script>
import { List, Cell, Empty } from 'vant'

export default {
    //--------------------------------------------------
	// component name
	//--------------------------------------------------
	name: 'org-match-suspension-report-list',

    //--------------------------------------------------
	// component components
	//--------------------------------------------------
    components: {
        'van-list': List,
        'van-cell': Cell,
        'van-empty': Empty,
    },

    //--------------------------------------------------
    // component emits
    //--------------------------------------------------
	emits: ['custom-event'],

    //--------------------------------------------------
    // component data
    //--------------------------------------------------
    data() {
        return {
            reportList: null,
            locale: {}
        }
    },

    //--------------------------------------------------
    // component computed
    //--------------------------------------------------
    computed: {
        isReportListEmtpy() {
            return this.reportList && (this.reportList.length == 0)
        }
    },

    //--------------------------------------------------
    // component methods
    //--------------------------------------------------
    methods: {
        onReportItemClick(item) {
            console.log('onReportItemClick', item.url)
            this.$emit('custom-event', {
                type: 'navigate',
                data: {
                    url: item.url
                }
            })
        },
    },
}
</script>

<template>
    <div class="match-suspension-report-list">
        <div v-if="!isReportListEmtpy">
            <van-list>
                <van-cell 
                    v-for="item in reportList" 
                    :key="item.id" 
                    :title="item.title"
                    :label="item.createTimeLabel"
                    is-link
                    center
                    @click="onReportItemClick(item)"
                >
                </van-cell>
            </van-list>
        </div>
        <div v-else>
            <van-empty 
                :description="locale['report-empty-hint']"
                image="search"
            />
        </div>
    </div>
</template>